<template>
  <!-- 我的课程详情 -->
  <div class="index-container">
    <div class="course-container">
      <div class="nav-box">
        首页 > 大健康人才培训 > 个人中心 > 我的课程
        <span>> 课程详情</span>
      </div>
      <personalSidebar>
        <div class="right-content">
          <div class="top-module">
            <div class="d-title">{{ info.title }}</div>
            <div
              class="detail-info-box"
              v-if="info['duty_teacher'] && info['duty_teacher'].length > 0"
            >
              <div
                class="info-img"
                :style="{
                  backgroundImage:
                    'url( ' + imgUrl + info['duty_teacher'][0]['avatar'] + ')',
                }"
              ></div>
              <div class="module-box">
                <div class="name">授课讲师</div>
                <div>{{ info["duty_teacher"][0]["name"] }}</div>
              </div>
              <div class="line">|</div>
              <div class="module-box">
                <div class="name">课程评分</div>
                <div>
                  {{ info.evaluate_avg }}
                  <span>（{{ info.count_evaluate }}人评价）</span>
                </div>
              </div>
              <div class="line">|</div>
              <div class="module-box" v-if="info.cate && info.cate.length > 0">
                <div class="name">课程类别</div>
                <div>{{ info.cate ? info.cate[0].title : "暂无" }}</div>
              </div>
              <div class="line">|</div>
              <div class="module-box">
                <div class="name">报名人数</div>
                <div>{{ info.report_count ? info.report_count : 0 }}</div>
              </div>
            </div>
          </div>
          <div class="catalogue-title">
            <span :class="sel === 1 ? 'sel' : ''" @click="sel = 1"
              >课程目录</span
            ><span
              @click="sel = 2"
              :class="sel === 2 ? 'sel' : ''"
              style="margin-left: 20px"
              >培训计划</span
            >
          </div>
          <div class="top-module">
            <div
              v-if="sel === 1"
              v-for="(item, index) in questionList"
              :key="index + 'one'"
            >
              <el-collapse>
                <el-collapse-item
                  :name="index"
                  v-if="item.child && item.child.length"
                >
                  <template slot="title">
                    <div class="second-title">
                      <!-- {{ item.level_id }} {{ item.level_name }} -->
                      {{ getSectionTitle(info, item, index) }}
                      <div class="num">
                        <span>{{ item.level_learn_count }}</span>
                        /{{ item.level_total_count }}
                      </div>
                    </div>
                  </template>
                  <div
                    class="q-words"
                    v-for="(item, index) in item.child"
                    :key="index"
                    :class="
                      item.class_model === 1
                        ? item.study === 1
                          ? ''
                          : 'no-look'
                        : ''
                    "
                  >
                    <div
                      class="q-type"
                      :class="item.class_model === 1 ? 'type-green' : ''"
                    >
                      {{ item.class_model == 1 ? "线上" : "" }}
                      {{ item.class_model == 2 ? "线下" : "" }}
                      {{ item.class_model == 3 ? "直播" : "" }}
                    </div>
                    {{ item.name }}
                    <span
                      @click="orderTimeSelect(item)"
                      class="q-link"
                      :class="item.study === 1 ? 'h-study' : ''"
                    >
                      {{
                        item.class_model === 1
                          ? item.study === 1
                            ? "已学习"
                            : "观看线上视频"
                          : item.class_model === 2
                          ? "预约上课时间"
                          : "跳转直播"
                      }}
                    </span>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div v-if="sel === 2">
              <embed
                v-if="imageUrl"
                :src="imageUrl + '#toolbar=0'"
                type="application/pdf"
                width="100%"
                height="800px"
                style="height: 800px"
              />
            </div>
          </div>
        </div>
      </personalSidebar>
    </div>
    <!-- 预约线下上课 -->
    <el-dialog
      class="form-box"
      :visible.sync="orderVisible"
      width="582PX"
      :close-on-click-modal="false"
    >
      <div class="order-title">预约上课</div>
      <template v-if="s_state == 2 || s_state == 0">
        <div class="order-info">
          上课地点
          <el-select
            v-model="classArea"
            @change="areaChange"
            placeholder="请选择校区"
          >
            <el-option
              v-for="(item, index) in classAreaList"
              :key="index + 'area'"
              :label="item.lession_address"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="order-info">
          上课时间
          <span>{{ time_range }}</span>
          <!-- <div class="time-box">
            <el-date-picker v-model="classTime" type="date" placeholder="选择日期"></el-date-picker>
            <el-time-select
              placeholder="起始时间"
              v-model="startTime"
              :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '23:30'
              }"
            ></el-time-select>
            <el-time-select
              placeholder="结束时间"
              v-model="endTime"
              :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '23:30',
                minTime: startTime
              }"
            ></el-time-select>
          </div>-->
        </div>
        <div class="order-button" @click="orderCourse">预约</div>
      </template>
      <template v-else>
        <div class>
          <div class="order-info info-box">
            上课地点
            <span>{{ orderInfo.lession_address }}</span>
            <div class="road-btn" @click="goGaode(orderInfo.lession_address)">
              <i class="iconfont-icon icon-daohang"></i> 去导航
            </div>
          </div>
          <div class="order-info">
            上课时间
            <span>{{ orderInfo.lession_time }}</span>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import personalSidebar from "../components/personalSidebar.vue";
import api from "../api/api";
import { imgUrl } from "../api/index";

export default {
  name: "myCourseDetail",
  components: {
    personalSidebar,
  },
  data() {
    return {
      sel: 1,
      imgUrl: imgUrl,
      info: {
        imgUrl: "",
        teacher: "",
        score: "",
        evaluateNum: 0,
        type: "",
        num: 0,
      },
      questionList: [],
      orderVisible: false,
      orderType: "",
      classArea: "",
      classAreaList: [],
      classTime: "",
      startTime: "",
      endTime: "",
      order_id: "",
      orderInfo: {
        lession_address: "",
        lession_time: "",
      },
      s_state: 0,
      time_range: "",
      section_uuid: "",
      imageUrl: "",
      // imgBase: 'https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/',
      imgBase: "https://train-service-cdn.oss-cn-shenzhen.aliyuncs.com/",
    };
  },
  mounted() {
    scrollTo(0, 0);
    const value = this.$route.query;
    if (value) {
      this.order_id = value.id;
      this.imageUrl = this.imgBase + value.pdf_url;
      this.getDetail(value.uuid);
      this.getTimetable();
    }
  },
  methods: {
    // 获取课程标题
    getSectionTitle(detail, item, index) {
      if (index == 0 && detail.high_alias) return detail.common_alias;
      if (index == 1 && detail.middle_alias) return detail.primary_alias;
      if (index == 2 && detail.primary_alias) return detail.middle_alias;
      if (index == 3 && detail.common_alias) return detail.high_alias;
      return `${item.level_id} ${item.level_name}`;
    },
    goGaode(address) {
      window.open(`https://www.amap.com/search?query=${address}`, "_blank");
    },
    getTimetable() {
      api.getTimetable({ order_id: this.order_id }).then((res) => {
        if (res && res.result.length > 0) {
          this.questionList = res.result;
        }
      });
    },
    //  获取详情
    getDetail(id) {
      api.getCourseDetail({ uuid: id }).then((res) => {
        if (res.result) {
          this.info = res.result;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 预约时间
    orderTimeSelect(item) {
      console.log(item);
      this.orderType = item.class_model;
      this.s_state = item.s_state;
      this.orderVisible = true;

      if (item.class_model == 1) {
        this.$router.push({
          path: "/myCoursePlay",
          query: { uuid: item.uuid },
        });
      } else if (item.class_model === 2) {
        this.classArea = "";
        this.time_range = "";
        this.section_uuid = item.uuid;
        // this.orderInfo.lession_address = item.subscribe.address;
        // this.orderInfo.lession_time = item.subscribe.date + item.subscribe.start_time + item.subscribe.end_time;
        if (item.s_state === 1 || item.s_state === 3) {
          this.orderInfo.lession_address = item.subscribe.address;
          this.orderInfo.lession_time =
            item.subscribe.date +
            " " +
            item.subscribe.start_time +
            " - " +
            item.subscribe.end_time;
        } else {
          this.orderInfo = item.class_info;
        }
        this.classAreaList = item.class_info;
      } else if (item.class_model === 3) {
        this.$router.push({
          path: "/playDetail",
          query: { uuid: item.live_uuid },
        });
      }
    },
    // 地址选择
    areaChange(val) {
      this.classArea = val.lession_address;
      this.time_range = val.lession_time;
    },
    // 预约课程
    orderCourse() {
      if (!this.classArea) {
        this.$message.warning("请选择预约地址和时间！");
        return;
      }
      const params = {
        time_range: this.time_range,
        address: this.classArea,
        section_uuid: this.section_uuid,
        subscribe_type: this.s_state,
      };
      api.courseSubscribe(params).then((res) => {
        if (res.result) {
          this.orderVisible = false;
          this.$message.success("预约成功！");
        } else {
          this.$message.warning(res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122px;
  background-color: #f8f7f6;
}
.course-container {
  padding-bottom: 10px;
}
.nav-box {
  width: 72%;
  margin: 0 auto;
  padding-top: 46px;
  font-size: 16px;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.right-content {
  width: 72%;
  //   padding: 32PX 48PX;
  background-color: #ffffff;
  .top-module {
    padding: 32px 48px;
  }
  .d-title {
    padding-bottom: 50px;
    font-size: 20px;
    font-weight: 600;
  }
  .second-title {
    position: relative;
    width: 96%;
    padding: 0 0 32px 18px;
    font-size: 16px;
    color: #333333;
    font-weight: 600;
  }
  .iconfont-icon {
    margin-top: 22px;
    font-size: 30px;
    color: #f1a373;
    cursor: pointer;
  }
  .num {
    position: absolute;
    top: 14px;
    right: 0;
    line-height: 20px;
    span {
      font-size: 20px;
      color: #f1a373;
    }
  }
  .q-type {
    margin-right: 10px;
    font-size: 14px;
  }
  .q-link {
    display: none;
    float: right;
    color: #f1a373;
    text-decoration: underline;
  }
  .h-study {
    font-size: 14px;
    color: #9a9a9a;
    text-decoration: none;
  }
  .q-words {
    width: 100%;
    padding: 8px 28px;
    margin-bottom: 24px;
    color: #333333;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      background-color: #f5f5f5;
      .q-link {
        display: block;
      }
    }
  }
  .no-look {
    color: #999999;
  }
  .q-type {
    display: inline-block;
    width: 36px;
    height: 20px;
    margin-right: 16px;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    text-align: center;
    background-color: #ff7b1f;
    border-radius: 5px;
  }
  .type-green {
    background-color: #52ce0f;
  }
}
.detail-info-box {
  display: flex;
  align-items: center;
  //   padding: 30PX 32PX;
  margin-bottom: 22px;
  .info-img {
    width: 70px;
    height: 70px;
    margin-right: 16px;
    border-radius: 50%;
    background-color: antiquewhite;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .module-box {
    font-size: 18px;
    font-weight: 600;
    .name {
      padding-bottom: 8px;
      font-size: 16px;
      color: #777777;
      font-weight: normal;
    }
    span {
      font-size: 14px;
    }
  }
  .line {
    padding: 0 2vw;
    font-size: 18px;
    color: #a6a4a4;
  }
}
.catalogue-title {
  //   width: 72PX;
  padding: 0 0 15px 50px;
  font-size: 18px;
  color: #a5a5a5;
  font-weight: 600;
  border-bottom: 1px solid #ececec;
  span {
    padding-bottom: 13px;
    // border-bottom: 3PX solid #f1a373;
  }
  .sel {
    color: #f1a373;
    border-bottom: 3px solid #f1a373;
  }
}
.order-title {
  padding-bottom: 40px;
  font-size: 22px;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
.order-info {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  color: #666666;
  span {
    padding-left: 16px;
    color: #333333;
  }
}
.info-box {
  margin-bottom: 40px;
}
.road-btn {
  width: 75px;
  margin-left: 12px;
  font-size: 12px;
  color: #1c87ff;
  text-align: center;
  line-height: 25px;
  border-radius: 14px;
  border: 1px solid #1c87ff;
  cursor: pointer;
  .iconfont-icon {
    position: relative;
    top: 2px;
  }
}
/deep/ {
  .el-collapse-item__header {
    border: none;
  }
  .el-collapse {
    border: none;
  }
  .el-dialog {
    padding: 0 20px 0;
    border-radius: 9px;
  }
  .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
  .el-select {
    flex: 1;
    margin-left: 14px;
  }
  .el-dialog__body {
    padding-top: 20px;
  }
  .el-date-editor {
    width: 134px;
    margin-right: 10px;
  }
}
.time-box {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  padding-left: 14px;
}
.order-button {
  width: 176px;
  margin: 40px auto;
  line-height: 44px;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  background: #f1a475;
  border-radius: 6px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/myCourseDetail.vue